import React, { useState } from 'react';
import { Collapse, Button, Card } from 'react-bootstrap';

function Instructions(props) {
    const [open, setOpen] = useState(props.open);

    if (props.long_instruction && props.long_instruction.long) {
        return (
            <div className="jumbotron pt-3 pb-3">
                <Collapse in={open}>
                    <div className="instructions" id="instructions">
                        <section id="general-instructions">
                        <div className="text-center">
                            <Button
                                onClick={() => {
                                    props.setOpen(!open);
                                    setOpen(!open);
                                }}
                                aria-controls="instructions"
                                aria-expanded={open}
                            >
                                Toggle Instructions
                            </Button>
                        </div>
                        <hr/>
                        <h2 className="text-center">Instructions</h2>
                        
                        In this task, you will be shown an instruction for text modification, an original text and a modified text, along with the modifications made to the original text. The goal is to check whether the modification is correct. You will need to choose one of two options: <br /><br />

                        1. <b>Yes</b>: if the modification follows instructions, and the modified text makes sense, is fluent and grammatical.<br />
                        2. <b>No</b>: if the modification doesn’t follow instructions, or the modified text does not make sense, is not fluent or grammatical.<br />
                        <br />
                        
                        Below you can find some <b>examples</b>.<br /><br />

                        <b>Text Modification Instruction</b>
                        <div style={{"textAlign": 'left'}}>
                            {props.long_instruction.long.task_desc.map(
                                (line, index) => (<p style={{margin: 0}} key={index}>{line}</p>)
                            )}
                        <br/>
                        </div>
                        
                        {/* <div style={{"textAlign": 'left'}}>
                            <p style={{margin: 0}}>Negate the text by making minimal modifications to introduce <b>lexical negation</b>.</p>
                            <p style={{margin: 0}}>Lexical negation: when the negation is added by substituting the main predicate of the sentence with its antonym or word carrying negative meaning.</p>
                            <p style={{margin: 0}}>Example</p>
                            <p>The house is big. &rarr;  The house is small.</p>
                        </div> */}

                        <p>
                            { props.long_instruction.long.examples.map(
                                (example, index) => (
                                    <div>
                                        <u>Example #{index+1}</u><br />
                                        <b>Original Text</b> = {example.original_text} <br/>
                                        <b>Modified Text</b> = {example.modified_text} <br/>
                                        <b>Answer</b> = {example.answer} <br/><br/>
                                    </div>
                                )
                            )}
                        </p>
                        
                        </section>
                        <hr/>
                    </div>
                </Collapse>
                <div className="text-center">
                    <div className="mb-20">
                        <Card className="" bg='danger'>
                            <Card.Body >
                                <Card.Title>Maintain quality work to remain qualified</Card.Title>
                                <Card.Text>
                                    <b>If your work quality is poor we will revoke your qualification and if it is very poor you will not be paid.</b>
                                    <br/>
                                    We will check your answers and ensure that your work quality remains high.
                                    The results of this task will be used to conduct <b>research</b>.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </div>
                    <Button
                        onClick={() => {
                            props.setOpen(!open);
                            setOpen(!open);
                        }}
                        aria-controls="instructions"
                        aria-expanded={open}
                    >
                        Toggle Instructions
                    </Button>
                </div>
            </div>
        );
    } else {
        return <div></div>
    }
}

export default Instructions;
